<div
    class="host-view"
    cdkScrollable
    [style.background-image]="
        hostViewWallpaperUrl ? 'url(' + hostViewWallpaperUrl + ')' : null
    "
>
    <div class="results-bar">
        <span class="sync-sweep" aria-hidden="true"></span>
        <div class="results-bar-header">
            <span class="total-votes">
                {{ results?.totalSelections ?? 0 | number }} Total Votes
            </span>

            @if (tenantLogoUrl) {
                <img class="tenant-logo" [src]="tenantLogoUrl" alt="logo" />
            }
        </div>
    </div>

    @if (poll; as poll) {
        <div class="cards">
            @if (poll.prompt) {
                <section class="card prompt-card">
                    <h2>Prompt</h2>
                    <p class="prompt">{{ poll.prompt }}</p>
                </section>
            }

            <section class="card results-card">
                <h2>Poll Results</h2>

                @if (results; as results) {
                    <!-- Gated on the vote total rather than row count: a poll with no votes still
                         returns one row per option, and ranking every one of them as a tie (`T-1`)
                         is worse than saying nothing has come in yet. -->
                    @if (results.totalSelections === 0) {
                        <div class="no-results">
                            <h3>No Poll Results Yet</h3>
                            <p>
                                Poll results will appear here as listeners cast
                                their votes.
                            </p>
                        </div>
                    } @else {
                        <!-- Multi-select gets the footer — paginator, rows-per-page and the
                             selections count — per the "Multi Select - Desktop" design. Single-select
                             has no footer, which also means the table renders every row unpaginated. -->
                        <!-- `host-poll-table` is styled from host-poll.overrides.scss, a global
                             stylesheet, since column widths live inside the shared table's own
                             template where this page's scoped styles cannot reach them. -->
                        <app-poll-results-table
                            class="host-poll-table"
                            [results]="results.results"
                            [showFooter]="poll.isMultiSelect"
                            [showTotalSelectionsInFooter]="poll.isMultiSelect"
                        />
                    }
                }
            </section>
        </div>
    }
</div>
